export const selectCloudStatus = (state) => state.cloud.status;
